import { request } from '@tencent/ppd-base-libs';
import { getLang, copyData } from '../util/index';
import { NcovDataType } from '../types';
import { i18n } from '@/i18n';

// 通用查询数据方法
async function query(type, lang = getLang()) {
  const data = await request.get(`/cgi-bin/refill/ncov_data_get.fcgi?noreport=1&data_type=${type}&language=${lang}`);
  if (!data || data.retcode !== '0') {
    throw new Error((data && data.retmsg) || 'System Buzy!');
  }
  return data;
}

export default {
  // 查询全球总数据统计
  async  queryTotalCase() {
    const data = {
      ncovData: [], // 全部全球统计数据
      newstCase: { // 最新全球统计数据
        data: {},
        updateTime: 0, // 最后更新时间
      },
    };
    const res = await query(NcovDataType.global_total_cases);
    const { ncov_data } = res;
    data.ncovData = ncov_data.map(item => ({
      date: item['As of date'].replace(/(\d{2})\/(\d{2})\/(\d{4})/mig, ($0, day, month) => `${month}.${day}`),
      updateTime: item['Update timestamp'],
      confirmed: item['Number of confirmed cases'],
      confirmedDiff: item['Number of confirmed cases diff'],
      death: item['Number of death cases'],
      deathDiff: item['Number of death cases diff'],
      territories: item['Number of territories with cases'],
      territoriesDiff: item['Number of territories with cases diff'],
    }));
    // 获取最新统计数据
    if (data.ncovData.length > 0) {
      const newst: any = data.ncovData[data.ncovData.length - 1];
      const defData = copyData(this.getDefNewstCaseData());
      const attrs = {
        confirmed: {
          value: newst.confirmed,
          diff: newst.confirmedDiff,
        },
        death: {
          value: newst.death,
          diff: newst.deathDiff,
        },
        territories: {
          value: newst.territories,
          diff: newst.territoriesDiff,
        },
      };
      for (const key in defData) {
        if (defData.hasOwnProperty(key)) {
          Object.assign(defData[key], attrs[key]);
        }
      }
      data.newstCase = {
        data: defData,
        updateTime: parseInt(newst.updateTime, 10),
      };
    }
    return data;
  },
  // 查询地区数据
  async  queryRegionCase() {
    let data = [];
    const res = await query(NcovDataType.global_region_cases);
    const { ncov_data } = res;
    if (ncov_data && ncov_data.length > 0) {
      data = ncov_data.map(item => ({
        area: item.Area,
        date: item['As of date'],
        confirmed: item['Number of confirmed cases'],
        confirmedDiff: item['Number of confirmed cases diff'],
        death: item['Number of death cases'],
      }));
    }
    return data;
  },
  // 获取默认最新统计信息数据
  getDefNewstCaseData() {
    return {
      confirmed: {
        value: 0,
        name: i18n('累計陽性個案'),
        diff: 0,
      },
      death: {
        value: 0,
        name: i18n('累計死亡'),
        diff: 0,
      },
      territories: {
        value: 0,
        name: i18n('已發現個案國家/地區'),
        diff: 0,
      },
    };
  },


};
